import { MapPin, Phone, Mail, Clock, Send } from 'lucide-react';
import { useState } from 'react';
import company from '../data/company.json';
import styles from './ContactSection.module.css';

export default function ContactSection() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = (e) => {
    e.preventDefault();
    // Replace with actual form submission logic
    setSent(true);
    setTimeout(() => setSent(false), 4000);
    setForm({ name: '', email: '', phone: '', subject: '', message: '' });
  };

  const { contact } = company;

  return (
    <section className={`${styles.section} section`} id="contact">
      <div className="container">
        <div className={styles.header}>
          <p className="section-label">Get In Touch</p>
          <h2 className="section-title">Contact Us</h2>
        </div>

        <div className={styles.grid}>
          {/* Info */}
          <div className={styles.info}>
            <p className={styles.infoText}>
              Have a project in mind or need expert advice on compressed air systems? Our team is ready to help you find the right solution.
            </p>
            <div className={styles.contacts}>
              <div className={styles.contactItem}>
                <MapPin size={18} className={styles.contactIcon} />
                <span>{contact.address}</span>
              </div>
              <div className={styles.contactItem}>
                <Phone size={18} className={styles.contactIcon} />
                <span>{contact.phone}</span>
              </div>
              <div className={styles.contactItem}>
                <Mail size={18} className={styles.contactIcon} />
                <span>{contact.email}</span>
              </div>
              <div className={styles.contactItem}>
                <Clock size={18} className={styles.contactIcon} />
                <span>{contact.hours}</span>
              </div>
            </div>
            <div className={styles.emergency}>
              <span className={styles.emergencyDot} />
              <div>
                <strong>24/7 Emergency Support</strong>
                <p>For critical breakdowns, call our emergency hotline anytime.</p>
              </div>
            </div>
          </div>

          {/* Form */}
          <form className={styles.form} onSubmit={handleSubmit}>
            {sent && (
              <div className={styles.successMsg}>
                ✓ Message sent! We'll get back to you within 24 hours.
              </div>
            )}
            <div className={styles.row}>
              <div className={styles.field}>
                <label className={styles.label}>Full Name *</label>
                <input name="name" value={form.name} onChange={handleChange} className={styles.input} placeholder="John Doe" required />
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Email Address *</label>
                <input name="email" type="email" value={form.email} onChange={handleChange} className={styles.input} placeholder="john@company.com" required />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles.field}>
                <label className={styles.label}>Phone Number</label>
                <input name="phone" value={form.phone} onChange={handleChange} className={styles.input} placeholder="+966 5X XXX XXXX" />
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Subject *</label>
                <select name="subject" value={form.subject} onChange={handleChange} className={styles.input} required>
                  <option value="">Select a subject</option>
                  <option>Product Inquiry</option>
                  <option>Service & Maintenance</option>
                  <option>Spare Parts</option>
                  <option>Emergency Support</option>
                  <option>General Inquiry</option>
                </select>
              </div>
            </div>
            <div className={styles.field}>
              <label className={styles.label}>Message *</label>
              <textarea name="message" value={form.message} onChange={handleChange} className={`${styles.input} ${styles.textarea}`} placeholder="Tell us about your requirements..." required rows={5} />
            </div>
            <button type="submit" className={styles.submitBtn}>
              <Send size={16} /> Send Message
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
